// extracted by mini-css-extract-plugin
export default {"container":"topCompanies_container__yCCee","border":"topCompanies_border__fdNPh"};